'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableFoot component, used to display the footer of a table. Renders a native HTML tfoot element.
 *
 * @example
 * <TableFoot>
 *   <TableRow>
 *     <TableCell>Total</TableCell>
 *     <TableCell>2</TableCell>
 *   </TableRow>
 * </TableFoot>
 */
const TableFoot = forwardRef(function TableFoot(rest, ref) {
    return jsx("tfoot", { ref: ref, ...rest });
});

export { TableFoot };
